import { Injectable, Signal } from "@angular/core";
import { UUID } from "../model/entityReference.model";
import { FileEntity } from "../model/file.model";
import { ApiClient } from "../service/network/api.client";
import { FileStore } from "../store/file.store";

@Injectable({
	providedIn: "root",
})
export class FileApi {
	constructor(
		private readonly api: ApiClient,
		private readonly store: FileStore,
	) {}

	public async fetch(id: string): Promise<void> {
		const fileEntity = await this.api.get<FileEntity>("/file/" + id);
		this.store.saveFile(fileEntity);
	}

	public all(): Signal<FileEntity[]> {
		return this.store.entities;
	}

	public byId(id: UUID): Signal<FileEntity | undefined> {
		this.store.updateById(id);
		return this.store.byIdEntity;
	}

	public syncById(id: string): FileEntity | undefined {
		return this.store.syncById(id);
	}
}
